import { CMS_API } from '@webapp/common/conf';

export interface CmsPage {
    id: string;
    parentId: string | null;
    rewrite: string;
    browserTitle: string;
    keywords: string;
    descr: string;
    content: string;
    title: string;
}

export const fetchPage = async (
    slug: string
): Promise<{
    content?: Array<CmsPage>;
    notFound?: boolean;
    blogData?: CmsPage;
}> => {
    try {
        const url = `${CMS_API}/content/${slug}`;

        const res = await fetch(url, {
            mode: 'cors'
        });

        const data = await res.json();

        if (data.status === 'ERROR') {
            return { notFound: true };
        }

        const { rows: content, ...rest } = data;

        return { content, ...rest };
    } catch (e) {
        console.error(e);
        return { notFound: true };
    }
};

export const fetchBlogPages = async (
    page: number,
    limit: number
    // ua?: string
): Promise<{ rows: Array<AnyObject>; total: number }> => {
    try {
        const url = `${CMS_API}/content/blog?page=${page}&limit=${limit}`;

        const res = await fetch(url, {
            mode: 'cors',
            credentials: 'include',
            headers: {
                'Access-Control-Request-Headers': 'Content-Type',
                'Access-Control-Request-Method': 'OPTIONS, POST'
                // [ua ? 'User-Agent' : undefined]: ua
            }
        });
        const { rows, status, total } = await res.json();

        if (status === 'ERROR') {
            return null;
        }

        return { rows, total };
    } catch (e) {
        console.error(e);
    }

    return null;
};
